/**
 * Het filter 'Label' op projecten: één label tegelijk, '' = alle labels.
 * Gedeeld door het projectenoverzicht en de dashboardkaart 'Projecten met
 * ster'. Zonder ingestelde labels is er niets te kiezen en verschijnt het niet.
 * AI-CONTEXT: See src/helpers/portfolio/projectMarks.js
 *
 * @param {object} props
 * @param {Array<{id: string, label: string}>} props.options - De zichtbare labels van deze organisatie
 * @param {string} props.value - De gekozen labelsleutel, '' = alle
 * @param {(key: string) => void} props.onChange - Krijgt de nieuwe sleutel
 * @returns {JSX.Element | null}
 */
const ProjectLabelFilter = ({ options, value, onChange }) => {
    if (options.length === 0) return null
    return (
        <select
            aria-label="Label"
            title="Label"
            className={`table-filter${value ? ' table-filter--active' : ''}`}
            value={value}
            onChange={(e) => onChange(e.target.value)}
        >
            <option value="">Alle labels</option>
            {options.map((o) => (
                <option key={o.id} value={o.id}>{o.label}</option>
            ))}
        </select>
    )
}

export default ProjectLabelFilter
